import { render, staticRenderFns } from "./HomeworkOpenTimeList.vue?vue&type=template&id=23df1794"
import script from "./HomeworkOpenTimeList.vue?vue&type=script&lang=js"
export * from "./HomeworkOpenTimeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports